// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file configurable.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file configurable.proto.
 */
export const file_configurable: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct]);

/**
 * @generated from message cryptotrader.ProviderConfig
 */
export type ProviderConfig = Message<"cryptotrader.ProviderConfig"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: google.protobuf.Struct config = 2;
   */
  config?: JsonObject | undefined;
};

/**
 * Describes the message cryptotrader.ProviderConfig.
 * Use `create(ProviderConfigSchema)` to create a new message.
 */
export const ProviderConfigSchema: GenMessage<ProviderConfig> = /*@__PURE__*/
  messageDesc(file_configurable, 0);

/**
 * @generated from message cryptotrader.ConfigurableList
 */
export type ConfigurableList = Message<"cryptotrader.ConfigurableList"> & {
  /**
   * @generated from field: repeated string account_providers = 1;
   */
  accountProviders: string[];

  /**
   * @generated from field: repeated string market_providers = 2;
   */
  marketProviders: string[];

  /**
   * @generated from field: repeated string strategies = 3;
   */
  strategies: string[];

  /**
   * @generated from field: repeated string engines = 4;
   */
  engines: string[];

  /**
   * @generated from field: repeated string notification_channels = 5;
   */
  notificationChannels: string[];
};

/**
 * Describes the message cryptotrader.ConfigurableList.
 * Use `create(ConfigurableListSchema)` to create a new message.
 */
export const ConfigurableListSchema: GenMessage<ConfigurableList> = /*@__PURE__*/
  messageDesc(file_configurable, 1);

/**
 * @generated from message cryptotrader.ParamSpec
 */
export type ParamSpec = Message<"cryptotrader.ParamSpec"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: cryptotrader.ParamType type = 2;
   */
  type: ParamType;

  /**
   * can be string, number, bool, null
   *
   * @generated from field: google.protobuf.Value default_value = 3;
   */
  defaultValue?: Value | undefined;

  /**
   * @generated from field: repeated string options = 4;
   */
  options: string[];

  /**
   * @generated from field: optional double min = 5;
   */
  min?: number | undefined;

  /**
   * @generated from field: optional double max = 6;
   */
  max?: number | undefined;

  /**
   * @generated from field: bool secret = 7;
   */
  secret: boolean;

  /**
   * @generated from field: string group = 8;
   */
  group: string;

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * for type=SCRIPT: "pine", etc.
   *
   * @generated from field: string script_type = 10;
   */
  scriptType: string;

  /**
   * @generated from field: string display = 12;
   */
  display: string;

  /**
   * for type=CONFIGURABLE
   *
   * @generated from field: cryptotrader.ConfigurableCategory category = 11;
   */
  category: ConfigurableCategory;
};

/**
 * Describes the message cryptotrader.ParamSpec.
 * Use `create(ParamSpecSchema)` to create a new message.
 */
export const ParamSpecSchema: GenMessage<ParamSpec> = /*@__PURE__*/
  messageDesc(file_configurable, 2);

/**
 * @generated from message cryptotrader.ParamsResponse
 */
export type ParamsResponse = Message<"cryptotrader.ParamsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.ParamSpec params = 1;
   */
  params: ParamSpec[];

  /**
   * Set when the component's Configure failed partway (e.g. a required
   * script source is still missing) and only a partial spec list was recorded.
   *
   * @generated from field: string warning = 2;
   */
  warning: string;
};

/**
 * Describes the message cryptotrader.ParamsResponse.
 * Use `create(ParamsResponseSchema)` to create a new message.
 */
export const ParamsResponseSchema: GenMessage<ParamsResponse> = /*@__PURE__*/
  messageDesc(file_configurable, 3);

/**
 * @generated from message cryptotrader.ValidateResponse
 */
export type ValidateResponse = Message<"cryptotrader.ValidateResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * empty when valid
   *
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message cryptotrader.ValidateResponse.
 * Use `create(ValidateResponseSchema)` to create a new message.
 */
export const ValidateResponseSchema: GenMessage<ValidateResponse> = /*@__PURE__*/
  messageDesc(file_configurable, 4);

/**
 * @generated from message cryptotrader.GetParamsRequest
 */
export type GetParamsRequest = Message<"cryptotrader.GetParamsRequest"> & {
  /**
   * @generated from field: cryptotrader.ConfigurableCategory category = 1;
   */
  category: ConfigurableCategory;

  /**
   * provider/strategy/engine name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Current configuration values — params can be cascading (e.g. selecting a
   * market provider may expose new params that depend on the provider choice).
   * The server uses these values to resolve dependent param defaults/options.
   *
   * @generated from field: google.protobuf.Struct config = 3;
   */
  config?: JsonObject | undefined;
};

/**
 * Describes the message cryptotrader.GetParamsRequest.
 * Use `create(GetParamsRequestSchema)` to create a new message.
 */
export const GetParamsRequestSchema: GenMessage<GetParamsRequest> = /*@__PURE__*/
  messageDesc(file_configurable, 5);

/**
 * Category-neutral metadata shared by preview and application discovery.
 *
 * @generated from message cryptotrader.ProviderInfosResponse
 */
export type ProviderInfosResponse = Message<"cryptotrader.ProviderInfosResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.ProviderCategory providers = 1;
   */
  providers: ProviderCategory[];
};

/**
 * Describes the message cryptotrader.ProviderInfosResponse.
 * Use `create(ProviderInfosResponseSchema)` to create a new message.
 */
export const ProviderInfosResponseSchema: GenMessage<ProviderInfosResponse> = /*@__PURE__*/
  messageDesc(file_configurable, 6);

/**
 * @generated from message cryptotrader.ProviderCategory
 */
export type ProviderCategory = Message<"cryptotrader.ProviderCategory"> & {
  /**
   * @generated from field: cryptotrader.ConfigurableCategory category = 1;
   */
  category: ConfigurableCategory;

  /**
   * @generated from field: repeated cryptotrader.ProviderInfo providers = 2;
   */
  providers: ProviderInfo[];
};

/**
 * Describes the message cryptotrader.ProviderCategory.
 * Use `create(ProviderCategorySchema)` to create a new message.
 */
export const ProviderCategorySchema: GenMessage<ProviderCategory> = /*@__PURE__*/
  messageDesc(file_configurable, 7);

/**
 * @generated from message cryptotrader.ProviderInfo
 */
export type ProviderInfo = Message<"cryptotrader.ProviderInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * @generated from field: string logo = 4;
   */
  logo: string;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * @generated from field: repeated cryptotrader.ProviderTemplate templates = 6;
   */
  templates: ProviderTemplate[];
};

/**
 * Describes the message cryptotrader.ProviderInfo.
 * Use `create(ProviderInfoSchema)` to create a new message.
 */
export const ProviderInfoSchema: GenMessage<ProviderInfo> = /*@__PURE__*/
  messageDesc(file_configurable, 8);

/**
 * @generated from message cryptotrader.ProviderTemplate
 */
export type ProviderTemplate = Message<"cryptotrader.ProviderTemplate"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: map<string, string> static_options = 4;
   */
  staticOptions: { [key: string]: string };

  /**
   * @generated from field: bool default = 5;
   */
  default: boolean;
};

/**
 * Describes the message cryptotrader.ProviderTemplate.
 * Use `create(ProviderTemplateSchema)` to create a new message.
 */
export const ProviderTemplateSchema: GenMessage<ProviderTemplate> = /*@__PURE__*/
  messageDesc(file_configurable, 9);

/**
 * @generated from enum cryptotrader.ParamType
 */
export enum ParamType {
  /**
   * @generated from enum value: PARAM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PARAM_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: PARAM_TYPE_INT = 2;
   */
  INT = 2,

  /**
   * @generated from enum value: PARAM_TYPE_FLOAT = 3;
   */
  FLOAT = 3,

  /**
   * @generated from enum value: PARAM_TYPE_BOOL = 4;
   */
  BOOL = 4,

  /**
   * @generated from enum value: PARAM_TYPE_SELECT = 5;
   */
  SELECT = 5,

  /**
   * @generated from enum value: PARAM_TYPE_ED25519 = 6;
   */
  ED25519 = 6,

  /**
   * @generated from enum value: PARAM_TYPE_SCRIPT = 7;
   */
  SCRIPT = 7,

  /**
   * @generated from enum value: PARAM_TYPE_CONFIGURABLE = 8;
   */
  CONFIGURABLE = 8,

  /**
   * @generated from enum value: PARAM_TYPE_DATETIME = 9;
   */
  DATETIME = 9,

  /**
   * @generated from enum value: PARAM_TYPE_SYMBOL = 10;
   */
  SYMBOL = 10,

  /**
   * @generated from enum value: PARAM_TYPE_TIMEFRAME = 11;
   */
  TIMEFRAME = 11,
}

/**
 * Describes the enum cryptotrader.ParamType.
 */
export const ParamTypeSchema: GenEnum<ParamType> = /*@__PURE__*/
  enumDesc(file_configurable, 0);

/**
 * @generated from enum cryptotrader.ConfigurableCategory
 */
export enum ConfigurableCategory {
  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_ACCOUNT_PROVIDER = 1;
   */
  ACCOUNT_PROVIDER = 1,

  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_MARKET_PROVIDER = 2;
   */
  MARKET_PROVIDER = 2,

  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_STRATEGY = 3;
   */
  STRATEGY = 3,

  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_ENGINE = 4;
   */
  ENGINE = 4,

  /**
   * @generated from enum value: CONFIGURABLE_CATEGORY_NOTIFICATION_CHANNEL = 5;
   */
  NOTIFICATION_CHANNEL = 5,
}

/**
 * Describes the enum cryptotrader.ConfigurableCategory.
 */
export const ConfigurableCategorySchema: GenEnum<ConfigurableCategory> = /*@__PURE__*/
  enumDesc(file_configurable, 1);

